export default {"textStyle":{"textAlignment":"AUTO","lineHeight":null},"indentation":0,"level":null}